import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";

const SetInteractionFolderNameModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const [folderName, setFolderName] = useState(modalStore.modalData.folderName || "");

    const isAddNew = !!modalStore.modalData.isAddNew;
    const trimmedName = folderName && folderName.trim();

    const renderBody = () => {
        return (
            <input
                className='site-prep-name-input'
                placeholder={generalStore.translate('addName')}
                value={folderName}
                onChange={e => setFolderName(e.target.value)}
            />
        )
    }

    const checkSameName = () => {
        let sameName;
        const folderMap = modalStore.modalData.folderMap || new Map();
        const currentFolder = modalStore.modalData.currentFolder;
        folderMap?.forEach(folder => {
            if (folder.parentFolder === currentFolder && folder.FolderName === folderName) {
                sameName = true;
            }
        });
        return sameName;
    }

    const onConfirm = async () => {
        if (folderName === 'root') {
            return modalStore.showErrorMessage(generalStore.translate('illegalFolderName'));
        } else if (checkSameName()) {
            return modalStore.showErrorMessage(generalStore.translate('folderWithSameNameAlreadyExistsInCurrentFolder'));
        }
        modalStore.modalData.folderName = folderName;
        await modalStore.modalData.onConfirm();
        modalStore.isSetInteractionFolderNameModalOpen = false;
    }

    const onEnter = () => setFolderName(modalStore.modalData.folderName || "");

    return (
        <GeneralDialog
            openControl='isSetInteractionFolderNameModalOpen'
            className={'procedure-option-dialog site-prep-options'}
            onEnter={onEnter}
            title={generalStore.translate('nameFolder')}
            body={renderBody()}
            isConfirmDisabled={!trimmedName}
            confirmText={generalStore.translate(isAddNew ? 'addNew' : 'rename')}
            onConfirm={onConfirm}
        />
    );
});

export default SetInteractionFolderNameModal;